import http from '@/utils/http'
import { createApp } from 'vue'
import advWindowPoper from './index.vue'
import type { AdvWindowPoperProps } from './index.type'

const open = (is: boolean | number = false) => {
  if (typeof is === 'boolean') {
    is = 2
  }
  if (!sessionStorage.getItem('yt_advWindowPoper_key') || is) {
    sessionStorage.setItem('yt_advWindowPoper_key', 'true')

    getWindow().then((data) => {
      if (data && data.imageUrl) {
        const box = document.createElement('div')
        const Instance = createApp(advWindowPoper as any, {
          model: data,
          number: Number(is),
          onClosed: () => {
            Instance.unmount()
            box.remove()
          }
        })
        document.body.appendChild(box)
        Instance.mount(box)
      }
    })
  }
}

const getWindow = () => {
  function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  let uuid = localStorage.getItem('uuid')
  if (!uuid) {
    uuid = guid()
    localStorage.setItem('uuid', uuid)
  }
  return new Promise<AdvWindowPoperProps>((resolve, reject) => {
    http
      .get('/api/webWindow/getWindow', { uuid })
      .then((res) => {
        const data: AdvWindowPoperProps = res.data
        resolve(data)
      })
      .catch(() => {
        reject()
      })
  })
}

export default open
